import { IContent, IResponseList } from '@zmedia/bm-soccer-ui/interface';
import { getWithPath } from '@zmedia/bm-soccer-ui/utils/http';

export const API_PATH = {
    GET_LIST: '/content/get/list',
};

export const ContentService = {
    getList(path: string, params: {}): Promise<IResponseList<IContent>> {
        return getWithPath(path, params);
    },
};

export default ContentService;
